import React, { ReactElement } from 'react';
import { Navigate } from 'react-router';
import { useSearchParams } from 'react-router-dom';

interface Props {
  children: ReactElement;
}

const PublicRoute: React.FC<Props> = ({ children }) => {
  //todo put auth condition here
  const [searchParams] = useSearchParams();
  const hasToken = searchParams.has('token');
  const isReceiptPath = window.location.pathname === '/receipt';
  // if (!hasToken && !isReceiptPath) return <Navigate to={`/not-found`} />;
  return children;
};

export default PublicRoute;
